/* eslint-disable */ 
import React from 'react' ;

export default function Divider () {
    return <div style={{height:1, width:'100%',marginTop:10, marginBottom:10, backgroundColor:'#ccc'}}/>
}